import { skillMaps } from "routes/skill-mapper/controller/skill-maps"

export async function getUniqueCopyName(originalName) {
    const baseName = originalName.replace(/\s*-- Copy(?:\s+\d+)?$/, "")
    const result = await skillMaps({ search: baseName, take: 500, status: "all" })
    const existingNames = new Set((result?.items ?? []).map(toName))

    if (!existingNames.has(`${baseName} -- Copy`)) {
        return `${baseName} -- Copy`
    }

    let n = 2
    while (existingNames.has(`${baseName} -- Copy ${n}`)) {
        n++
    }
    return `${baseName} -- Copy ${n}`
}

function toName(m) {
    return m.name
}
